<template>
  <div>
  <div
    class="payment-schedule-table hidden lg:block xl:block"
  >
    <table class="table-auto w-full">
      <thead>
      <tr>
        <th class="px-4 py-2">
          Ngày
        </th>
        <th class="px-4 py-2">
          Giao dịch
        </th>
        <th class="px-4 py-2">
          Ngày hiệu lực
        </th>
        <th class="px-4 py-2">
          Số tiền
        </th>
        <th class="px-4 py-2">
          Gốc
        </th>
        <th class="px-4 py-2">
          Lãi
        </th>
        <th class="px-4 py-2">
          Phạt chậm thanh toán
        </th>
        <th class="px-4 py-2">
          Dư nợ
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in paymentHistories" :key="index">
        <td
          class="border px-4 py-2 text-center"
          v-if="item.PaymentDate && item.PaymentDate !== null"
        >
          {{item.PaymentDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY')}}
        </td>
        <td
          class="border px-4 py-2 text-center"
          v-else
        >
        </td>
        <td
          class="border px-4 py-2"
        >
          {{item.PaymentStatus}}
        </td>
        <td
          class="border px-4 py-2"
          v-if="item.PaymentEffectiveDate && item.PaymentEffectiveDate !== null"
        >
          {{item.PaymentEffectiveDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY')}}
        </td>
        <td
          class="border px-4 py-2"
          v-else
        >

        </td>
        <td
          class="border px-4 py-2"
        >
          {{Number(item.AmountPaidInPeriod).toLocaleString()}}
        </td>
        <td
          class="border px-4 py-2"
        >
          {{Number(item.Origin).toLocaleString()}}
        </td>
        <td
          class="border px-4 py-2"
        >
          {{Number(item.InterestRate).toLocaleString()}}
        </td>
        <td
          class="border px-4 py-2"
        >
          {{Number(item.Pen).toLocaleString()}}
        </td>
        <td
          class="border px-4 py-2"
        >
          {{Number(item.BeginningBalance).toLocaleString()}}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div
    class="payment-schedule-mobile block lg:hidden"
  >
    <div class="mobile-schedule-header">
      <p>Ngày</p>
      <p>Giao dịch</p>
    </div>
    <div
      class="mobile-schedule-content"
    >
      <div class="shadow-md">
        <div
          class="tab w-full overflow-hidden border-t"
          v-for="(item, index) in paymentHistories" :key="index"
        >
          <input
            class="absolute opacity-0 "
            :id="'tab-multi-' + index"
            type="checkbox"
            name="tabs"
          />
          <label
            class="block p-4 cursor-pointer flex justify-between"
            :for="'tab-multi-'+ index"
          >
              <span
                class="flex items-center"
              >
                  <img
                    class="mr-3 block"
                    src="@/assets/img/icon_plus.svg"
                    alt=""
                  />
                  <img
                    class="mr-3 hidden"
                    src="@/assets/img/icon_plus_2.svg"
                    alt=""
                  />
                  <p  v-if="item.PaymentDate && item.PaymentDate !== null">{{item.PaymentDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY')}}</p>
                  <p v-else></p>
              </span>
            <span>{{item.PaymentStatus}}</span>
          </label>
          <div
            class="tab-content overflow-hidden"
          >
            <div
              class="flex flex-row p-4 pt-0"
            >
              <div
                class="w-1/2"
              >
                <p>Ngày hiệu lực:</p>
                <p>Số tiền:</p>
                <p>Gốc:</p>
                <p>Lãi:</p>
                <p>Phạt chậm thanh toán:</p>
                <p>Dư nợ:</p>
              </div>
              <div
                class="w-1/2"
              >
                <p  v-if="item.PaymentEffectiveDate && item.PaymentEffectiveDate !== null">
                  {{item.PaymentEffectiveDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY')}}
                </p>
                <p v-else></p>
                <p>
                  {{Number(item.AmountPaidInPeriod).toLocaleString()}}
                </p>
                <p>
                  {{Number(item.Origin).toLocaleString()}}
                </p>
                <p>
                  {{Number(item.InterestRate).toLocaleString()}}
                </p>
                <p>
                  {{Number(item.Pen).toLocaleString()}}
                </p>
                <p>
                  {{Number(item.BeginningBalance).toLocaleString()}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    <div v-if="paymentHistories.length > 0" class="loan-detail-bottom-wrapper">
      <div class="loan-detail-bottom-button">
        <button class="loan-button" @click="makePdf(contractNo)">
          <i>
            <svg width="14px" height="12px" viewBox="0 0 14 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g stroke-width="1" fill="none" fill-rule="evenodd" stroke="currentColor"> <g transform="translate(-7.000000, -12.000000)"> <g transform="translate(8.000000, 13.000000)"> <polyline stroke-width="1.05263158" points="4.21052632 7.89473684 6.31578947 10 8.42105263 7.89473684"></polyline> <line x1="6.31578947" y1="5.26315789" x2="6.31578947" y2="10" stroke-width="1.05263158"></line> <path d="M10.9894737,8.46842107 L10.9894737,8.46842107 C12.1783421,7.63241054 12.4643842,5.99092633 11.6283737,4.80205791 C11.135151,4.10065791 10.3311368,3.68354212 9.47368419,3.68421054 L8.81052629,3.68421054 L8.81052629,3.68421054 C8.23256313,1.43176843 5.93806313,0.0743421175 3.68562629,0.652305275 C1.43318418,1.23026843 0.0757578682,3.52476843 0.653721026,5.77720528 C0.819581026,6.42359475 1.13670576,7.02130001 1.57894734,7.52104738" stroke-width="1.05263158"></path> </g> </g> </g> </svg>
          </i>
          Tải dữ liệu
        </button>
      </div>
      <div class="loan-detail-bottom-pagination">
        <paginate
          v-model="pagination.page"
          :pageCount="pageCount"
          :containerClass="'pagination'"
          :prev-text="'<i class=&quot;iconvl icon-angle-left&quot;></i>'"
          :next-text="'<i class=&quot;iconvl icon-angle-right&quot;></i>'"
          :clickHandler="paginateCallback">
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import prepareQueryParamsMixin from '@/mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '@/mixins/prepareFetchParamsMixin'

// import DataBox from '@/components/DataBox'
import Paginate from 'vuejs-paginate'
import { PaymentHistoriesService } from '@/services/paymentHistories.service'

export default {
  name: 'PaymentHistory',
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  components: {
    // DataBox,
    Paginate
  },
  props: {
    contractNo: { type: String }
  },
  data () {
    return {
    }
  },
  methods: {
    fetchData () {
      this.$store.dispatch('paymentHistories/getListById', { id: this.contractNo, params: this.fetchParams })
    },
    paginateCallback: function (page) {
      this.$store.commit('paymentHistories/SET_PAGINATION', { page: page })
      this.fetchData()
    },
    makePdf (contractNo) {
      return PaymentHistoriesService.makePaymentHistoriesPdf(contractNo)
    }
  },

  computed: {
    ...mapState('paymentHistories', {
      paymentHistories: 'items',
      pagination: 'pagination',
      error: 'error',
      loading: 'loading'
    }),
    ...mapGetters('paymentHistories', [
      'isEmpty'
    ]),
    fetchParams () {
      const pagination = this.prepareFetchParamsMixin({
        pageIndex: this.pagination.page
      })

      return { ...pagination }
    },
    pageCount () {
      return Math.ceil(this.pagination.total / this.pagination.limit)
    }
  },

  created () {
    this.fetchData()
  }
}
</script>
<style lang="scss" scoped>
  @import '@/scss/components/_loanButton.scss';
</style>
